import { useNavigate, useSearchParams } from "react-router-dom";

import ClientContactLeadsForm from "features/admin/clients/single/ClientContactLeadsForm";
import ClientContactLeadsTable from "features/admin/clients/single/ClientContactLeadsTable";
import ClientRateCardForm from "features/admin/clients/single/ClientRateCardsForm";
import ClientRateCardsTable from "features/admin/clients/single/ClientRateCardsTable";
import HStack from "shared/components/layout/stack/HStack";
import Modal from "shared/components/feedback/modals/MasterModal";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "addRateCard") {
        return (
            <Modal title="Add Rate Card" onRequestClose={onClose}>
                <ClientRateCardForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    if (action === "addContactLead") {
        return (
            <Modal title="Add Contact Lead" onRequestClose={onClose}>
                <ClientContactLeadsForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "editRateCard" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Edit Rate Card" onRequestClose={onClose}>
                <ClientRateCardForm
                    rateCardIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "editContactLead" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Edit Contact Lead" onRequestClose={onClose}>
                <ClientContactLeadsForm
                    contactLeadIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const ClientContactsAndRateCards = () => {
    return (
        <>
            <FormPresenter />
            <HStack
                spacing="Two"
                justify="space-between"
                style={{ overflow: "auto" }}
            >
                <VStack style={{ width: "50%" }}>
                    <Text variant="Headline_2" color="Gray_1">
                        Contact Leads
                    </Text>
                    <ClientContactLeadsTable />
                </VStack>

                <VStack style={{ width: "50%" }}>
                    <Text variant="Headline_2" color="Gray_1">
                        Rate Cards
                    </Text>
                    <ClientRateCardsTable />
                </VStack>
            </HStack>
        </>
    );
};

export default ClientContactsAndRateCards;
